import index from '@/api/index';
import { http } from '@/api/request';
import { useStore } from '@/store';
import { ElMessage } from 'element-plus';

// axios.use 会返回 interceptor id；保存它用于后续安全 eject，防止重复挂载
let responseInterceptorId = null;

function ensureResponseInterceptor() {
  // SSR/插件重复执行时，避免重复注册导致 handlers 持续增长
  if (responseInterceptorId !== null) return;
  // 响应拦截器：专门处理 401 等需要 Store 的业务逻辑
  responseInterceptorId = http.interceptors.response.use(
    (response) => response,
    (error) => {
      const store = useStore();
      const bizConfig = error.config?._businessConfig || {};

      // 1. 处理 401 登录失效
      if (error?.code === 401) {
        if (process.client) {
          // 执行登出逻辑
          store.logOut(true);

          // 提示错误，防止多个请求同时 401 弹出多个提示
          // 使用 Store 中的 AlreadyShowErr 标记，确保 SSR 安全
          if (!store.AlreadyShowErr) {
            ElMessage({
              type: 'error',
              message: error.msg,
              duration: 3000,
            });
            store.SET_ALREADY_SHOW_ERR(true);
          }

          // 跳转
          setTimeout(() => {
            navigateTo('/register');
            store.SET_ALREADY_SHOW_ERR(false); // 跳转后重置
          }, 1000);
        } else {
          // 服务端 SSR 期间如果接口 401，直接通过 Nuxt 重定向
          return navigateTo('/register');
        }
      } else if (bizConfig.errorMsg !== false && error?.msg) {
        // 如果配置了 errorMsg 为 true（默认即为 true），且后端返回了错误信息，则弹出 Toast
        if (process.client) {
          ElMessage({
            type: 'error',
            message: error.msg,
            duration: bizConfig.duration || 3000,
          });
        }
      }

      return Promise.reject(error);
    },
  );
}

export default defineNuxtPlugin((nuxtApp) => {
  // 只在未注册时挂载拦截器，保证插件幂等
  ensureResponseInterceptor();

  nuxtApp.provide('api', index);
  nuxtApp.vueApp.provide('api', index);
});
